import { Component, OnInit } from "@angular/core";
import { DataService } from "../data.service";
import { Router, ActivatedRoute } from "@angular/router";
import { CountryService } from "../country.service";
import { IMyDpOptions, IMyDateModel, IMyDate } from "mydatepicker";
import { NgForm } from "@angular/forms";
import { EventsService } from "angular4-events";
import { Constants } from "../constants";

declare var $: any;
declare var Nanobar: any;
declare var google: any;
declare var toastr: any;
@Component({
  selector: "app-customer-detail",
  templateUrl: "./customer-detail.component.html",
  styleUrls: ["./customer-detail.component.css"],
})
export class CustomerDetailComponent implements OnInit {
  priceIconForDouble = Constants.iconForDoublePrice;
  customerOrderListing: any;
  CustomerOrderListingPage: any;
  customerOrderListingPagination = 0;
  lastPage: any;
  showRangeFields = false;
  ordertype = 0;
  searchOrder = "";
  noSearchData = false;
  loadindData = true;
  searchTimeOut: any;
  id: any;
  type: any;
  businessid = -1;
  startDate: any;
  endDate: any;
  businessAgainstCustomer: any;
  private sub: any;
  nao = new Nanobar();
  countryCode: any;
  countryCode2: any;
  maxYear: any;
  first_name: any;
  last_name: any;
  number: any;
  number2 = "";
  email: any;
  is_tax_exempt = false;
  accept_marketing = false;
  address_line1: any;
  address_line2: any;
  city: any;
  state: any;
  zip: any;
  dob: any;
  emailChk: any;
  area: any;
  apart: any;
  note: any;
  findCustomerData: any;
  customerMatch = false;
  customerMatchId = true;
  street: any;
  latitude: any;
  longitude: any;
  userImage: any;
  numChk = false;
  place: any;
  validateNumberSucces: any;
  validateChk = true;
  phoneNumToSend: any;
  btnDisable: any;
  restErrorCode: any;
  success: any;
  addingCustomer: any;
  error_count: any;
  errorMsg: any;
  clearTimeout: any;
  placeSuggestionsData: any;
  placeDetailData: any;
  placeDataFound = false;
  addressLoad = false;
  dobToDisplay: any;
  private today = new Date();
  selDate: any;
  selectAddress = false;
  addCustomerAddress: any;
  customerName = "";
  deleteAdddressData: any;
  gender: any = -1;
  myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: "mm/dd/yyyy",
    showTodayBtn: true,
    todayBtnTxt: "Today",
    showClearDateBtn: false,
    indicateInvalidDate: true,
    editableDateField: false,
    openSelectorOnInputClick: true,
    disableSince: { year: this.today.getFullYear() - 20, month: 1, day: 1 },
    // minYear: this.today.getFullYear() - 20,
    // disableSince: {year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() + 1}
    // disableUntil: {year: 0, month: 0, day: 0}
  };

  filterValue = "All";
  idvas: any;
  previousStateData: any;
  cId: any;

  constructor(
    private route: ActivatedRoute,
    private dataService: DataService,
    private router: Router,
    private cs: CountryService,
    private events: EventsService
  ) {
    this.sub = this.route.params.subscribe((params) => {
      this.id = +params["id"]; // (+) converts string 'id' to a number

      console.log("this.id", this.id);
    });
    this.idvas = this.events.subscribe("customerId").subscribe((data) => {
      console.log("data", data);
      this.previousStateData = data;
      this.id = data.id;
      this.findCustomer();
      this.getcustomerOrderListing();
      this.getbusinessesList();
    });
  }

  findNumber() {
    if (this.number2 === null || this.number2 === "") return;
    this.numChk = true;
    this.nao.go(30);
    var getCode = $("#phone").intlTelInput("getSelectedCountryData").dialCode;
    var num = "+" + getCode + this.number2;
    console.log("number", num);
    console.log("login data");
    this.dataService
      .validateNumber(window.localStorage.getItem("token"), num)
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.validateNumberSucces = data;
          this.validateNumberSucces = this.validateNumberSucces.success;
          this.validateChk = this.validateNumberSucces;
          if (this.validateChk === true) {
            this.numChk = false;
          }
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }
  findCustomer() {
    this.nao.go(30);
    this.dataService
      .showCustomerListById(window.localStorage.getItem("token"), this.id)
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.findCustomerData = data;
          if (this.findCustomerData.rest_error_code === 1)
            toastr.error("Some thing went wrong");
          if (this.findCustomerData.rest_error_code === 2)
            toastr.error("Please login again");
          if (this.findCustomerData.rest_error_code === 3)
            toastr.error("Customer already exists");
          // this.addCustomerAddress = data;

          this.findCustomerData = data;
          this.customerName =
            this.findCustomerData.first_name +
            " " +
            this.findCustomerData.last_name;
          this.addCustomerAddress = this.findCustomerData.address_list;
          this.number = this.findCustomerData.phone_number;
          this.number2 = this.findCustomerData.phone_number;
          this.cId = this.findCustomerData.id;
          this.countryCode = this.findCustomerData.country_code;
          this.phoneNumToSend = this.countryCode + this.number;
          console.log("this.number", this.phoneNumToSend);
          // $('#datepicker').val(this.findCustomerData.date_of_birth);
          //  this.dob = this.findCustomerData.date_of_birth;
          this.dobToDisplay = this.findCustomerData.date_of_birth;
          this.selDate = this.findCustomerData.date_of_birth;
          $("#phoneValue").val(this.number);
          this.first_name = this.findCustomerData.first_name;
          this.userImage = this.findCustomerData.img_url;
          this.last_name = this.findCustomerData.last_name;
          this.accept_marketing = this.findCustomerData.accept_marketing;
          this.is_tax_exempt = this.findCustomerData.tax_exempt;
          this.gender = this.findCustomerData.gender;
          this.email = this.findCustomerData.email;
          this.note = this.findCustomerData.note;
          this.street = this.findCustomerData.street;
          this.findCustomerData = this.findCustomerData.address;
          this.address_line1 = this.findCustomerData.address_line1;
          this.address_line2 = this.findCustomerData.address_line2;
          this.city = this.findCustomerData.city;
          this.state = this.findCustomerData.state;
          this.zip = this.findCustomerData.zip;
          this.area = this.findCustomerData.area;
          this.apart = this.findCustomerData.apart_no;
          this.longitude = this.findCustomerData.longitude;
          this.latitude = this.findCustomerData.latitude;
          if (
            this.findCustomerData.city !== null &&
            this.findCustomerData.city !== "" &&
            this.findCustomerData.address_line1 !== null &&
            this.findCustomerData.address_line1 !== ""
          ) {
            this.selectAddress = true;
            this.callMap();
          } else {
            this.selectAddress = false;
          }
          if (this.is_tax_exempt === true) {
            $("#is_tax_exempt").prop("checked", true);
          }
          if (this.accept_marketing === true) {
            $("#accept_marketing").prop("checked", true);
          }
          this.customerMatch = true;
          console.log("cutomer data get with phone#", data);
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }
  editCutomerFunction() {
    this.error_count = 0;
    $(".c-label label").css("color", "#3d3e3d");
    $(".uploadText").css("color", "#3d3e3d");
    $(".c-label input").css("border-color", "#ccc");
    $(".c-label textarea").css("border-color", "#ccc");
    this.addingCustomer = true;
    if ($("#is_tax_exempt").is(":checked")) {
      this.is_tax_exempt = true;
    }
    if ($("#accept_marketing").is(":checked")) {
      this.accept_marketing = true;
    }
    this.city = $("#city").val();
    this.zip = $("#zip").val();
    this.state = $("#state").val();
    this.area = $("#area").val();
    this.apart = $("#apart").val();
    // this.dob = $('#datepicker').val();
    console.log("dob before", this.dob);
    this.dob = this.dob.formatted;
    console.log("dob after", this.dob);
    this.number2 = $("#phoneValue").val();
    this.address_line1 = $("#c-address input").val();
    console.log("login data");
    if (this.first_name === "" || this.first_name === undefined) {
      $("#c-fname label").css("color", "#a10a0d");
      $("#c-fname input").css("border-color", "#a10a0d");
      this.error_count++;
    }
    if (this.last_name === "" || this.last_name === undefined) {
      $("#c-lname label").css("color", "#a10a0d");
      $("#c-lname input").css("border-color", "#a10a0d");
      this.error_count++;
    }
    if (this.number2 === "" || this.number2 === undefined) {
      // || this.numChk === true
      $("#c-phone label").css("color", "#a10a0d");
      $("#c-phone input").css("border-color", "#a10a0d");
      this.error_count++;
    }
    if (this.dob === "" || this.dob === undefined) {
      this.dob = this.dobToDisplay;
      // $('#c-dob label').css('color', '#a10a0d');
      // $('#c-dob input').css('border-color', '#a10a0d');
      // this.error_count ++;
    }

    if (this.gender === "" || this.gender === -1) {
      $("#c-gender label").css("color", "#a10a0d");
      $("#c-gender input").css("border-color", "#a10a0d");
      this.error_count++;
    }
    this.emailChk = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!this.emailChk.test(this.email) && this.email !== "") {
      $("#c-email label").css("color", "#a10a0d");
      $("#c-email input").css("border-color", "#a10a0d");
      this.error_count++;
    }
    // if (this.address_line1 === '' || this.address_line1 === undefined) {
    //   $('#c-address label').css('color', '#a10a0d');
    //   $('#c-address input').css('border-color', '#a10a0d');
    //   this.error_count ++;
    // }
    // if (this.city === '' || this.city === undefined) {
    //   $('#c-city label').css('color', '#a10a0d');
    //   $('#c-city input').css('border-color', '#a10a0d');
    //   this.error_count ++;
    // }
    // if (this.zip === '' || this.zip === undefined) {
    //   $('#c-zip label').css('color', '#a10a0d');
    //   $('#c-zip input').css('border-color', '#a10a0d');
    //   this.error_count ++;
    // }
    // if (this.state === '' || this.state === undefined) {
    //   $('#c-state label').css('color', '#a10a0d');
    //   $('#c-state input').css('border-color', '#a10a0d');
    //   this.error_count ++;
    // }
    // if (this.area === '' || this.area === undefined) {
    //   $('#c-area label').css('color', '#a10a0d');
    //   $('#c-area input').css('border-color', '#a10a0d');
    //   this.error_count ++;
    // }
    // if (this.error_count > 0) {
    //   return;
    // }
    if (this.number2 !== "" && this.number2 !== undefined) {
      // || this.numChk === true
      console.log("number", this.number2);
      var getCode = $("#phone").intlTelInput("getSelectedCountryData").dialCode;
      this.phoneNumToSend = "+" + getCode + "" + this.number2;
      console.log("number", this.phoneNumToSend);
    }
    // var getCode = $('#phone').intlTelInput('getSelectedCountryData').dialCode;
    // this.number = '+' + getCode + this.number;
    // console.log('number', this.number);
    // this.nao.go(30);
    this.btnDisable = true;
    this.street = this.address_line1;
    this.dataService
      .editCustomer(
        window.localStorage.getItem("token"),
        this.first_name,
        this.last_name,
        this.phoneNumToSend,
        this.email,
        this.is_tax_exempt,
        this.accept_marketing,
        this.note,
        this.dob,
        this.gender,
        this.id
      )
      .subscribe(
        (data) => {
          this.validateChk = true;
          console.log("outlet data");
          // this.nao.go(100);
          this.restErrorCode = data;
          this.restErrorCode = this.restErrorCode.rest_error_code;
          this.success = data;
          this.errorMsg = data;
          this.errorMsg = this.errorMsg.message;
          this.success = this.success.success;
          if (this.restErrorCode === 1) {
            toastr.error("Some thing went wrong");
            this.btnDisable = false;
          }
          if (this.restErrorCode === 2) {
            toastr.error("Please login again");
            this.btnDisable = false;
          }
          if (this.restErrorCode === 3) {
            toastr.error("Customer already exists");
            this.btnDisable = false;
          }
          if (this.restErrorCode === 4) {
            toastr.error("Customer does not exist");
            this.btnDisable = false;
          }
          if (this.success === true) {
            this.btnDisable = false;
            toastr.success("Successfully updated");
            // this.router.navigate(['customers']);
            this.editClose();
          }
          if (this.success === false) {
            this.addingCustomer = false;
            this.btnDisable = false;
            toastr.error(this.errorMsg);
          }
        },
        (error) => {
          // this.nao.go(100);
          this.addingCustomer = false;
          this.btnDisable = false;
          console.log("error", error);
        }
      );
  }
  deleteAddress(id) {
    this.dataService
      .deleteCustomerAddress(window.localStorage.getItem("token"), this.id, id)
      .subscribe(
        (data) => {
          // this.nao.go(100);
          this.deleteAdddressData = data;
          if (this.deleteAdddressData.success === true) {
            toastr.success("Successfully removed address of customer");
            this.findCustomer();
          } else {
            toastr.error("Something went wrong");
          }
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }
  editUser() {
    this.callMap();
    this.customerMatch = false;
    var context = this;
    $(function () {
      setTimeout(() => {
        $("#phone").intlTelInput({
          // autoFormat: true,
          utilsScript:
            "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/12.1.9/js/utils.jss",
          autoPlaceholder: false,
          preferredCountries: context.countryCode,
          preventInvalidNumbers: true,
          // stop the user from typing invalid dial codes
          preventInvalidDialCodes: true,
          formatOnDisplay: true,
          separateDialCode: false,
        });
        $("#phone").on("countrychange", function (e, countryData) {
          console.log("chk in intel input change event");
          if (context.number === null || context.number === "") {
            return;
          } else {
            context.findNumber();
          }
        });
      }, 2000);
      setTimeout(() => {
        //   countryCode = $('#phone').intlTelInput('getSelectedCountryData').dialCode;
        $("#phone").val(context.countryCode);
        $(function () {
          // $('#phone').focus();
          console.log("trigger");
          var e = $.Event("keypress", { which: 13 });
          $("#phone").trigger(e);
        });
      }, 1000);
      var countryCode;
      $("#phone").change(function () {
        countryCode = $("#phone").intlTelInput("getSelectedCountryData")
          .dialCode;
        $("#phone").val("+" + countryCode);
      });
    });
  }
  // addressDetail() {
  //  this.street = '';
  //  console.log('chk address detail', this.place);
  //     for(var i = 0; i < this.place.address_components.length; i++) {
  //    for(var j = 0; j < this.place.address_components[i].types.length; j++) {
  //      // if (this.place.address_components[i].types[j] === 'administrative_area_level_2') {
  //      //   // this.city = this.place.address_components[i].long_name;
  //      //   // console.log('city', this.city);
  //      //    $('#city').val(this.place.address_components[i].long_name);
  //      // }
  //      if (this.place.address_components[i].types[j] === 'locality') {
  //        // this.city = this.place.address_components[i].long_name;
  //        // console.log('city', this.city);
  //         $('#city').val(this.place.address_components[i].long_name);
  //      }
  //       if (this.place.address_components[i].types[j] === 'street_number') {
  //        this.street = this.place.address_components[i].long_name;
  //        console.log('street number', this.street);
  //      }
  //      if (this.place.address_components[i].types[j] === 'route') {
  //        this.street = this.street + ' ' + this.place.address_components[i].long_name;
  //        console.log('route', this.street);
  //      }
  //      if (this.place.address_components[i].types[j] === 'sublocality_level_2') {
  //        this.street = this.street + ' ' + this.place.address_components[i].long_name;
  //        console.log('sublocality 2', this.street);
  //      }
  //      if (this.place.address_components[i].types[j] === 'sublocality_level_1') {
  //        this.street = this.street + ' ' + this.place.address_components[i].long_name;
  //        console.log('sublocality 1', this.street);
  //      }
  //      //   this.street = this.place.name;
  //      //   console.log('this.street', this.street);
  //
  //      if (this.place.address_components[i].types[j] === 'administrative_area_level_1') {
  //        // this.state = this.place.address_components[i].long_name;
  //        $('#state').val(this.place.address_components[i].short_name);
  //      }
  //
  //      if (this.place.address_components[i].types[j] === 'country') {
  //        // this.area = this.place.address_components[i].long_name;
  //        $('#area').val(this.place.address_components[i].long_name);
  //      }
  //
  //      if (this.place.address_components[i].types[j] === 'postal_code') {
  //        // this.zip = this.place.address_components[i].long_name;
  //        console.log('postal; code', this.place.address_components[i].long_name);
  //        $('#zip').val(this.place.address_components[i].long_name);
  //      } else {
  //          $('#zip').val('');
  //      }
  //      this.latitude = this.place.geometry.location.lat();
  //        this.longitude = this.place.geometry.location.lng();
  //
  //      }
  //    }
  //  }
  // inputAddress1() {
  //   var context = this;
  //   console.log('inputAddress');
  //
  //   const input = document.getElementById('searchTextField');
  //
  //   const searchBox = new google.maps.places.Autocomplete(input);
  //   searchBox.addListener('place_changed', function() {
  //
  //     console.log('place changed');
  //     context.place = searchBox.getPlace();
  //     console.log('address', context.place);
  //     context.addressDetail();
  //   });
  // }
  addressDetail() {
    this.street = "";
    console.log("chk address detail", this.place);
    for (var i = 0; i < this.placeDetailData.length; i++) {
      for (var j = 0; j < this.placeDetailData[i].types.length; j++) {
        // if (this.place.address_components[i].types[j] === 'administrative_area_level_2') {
        //   // this.city = this.place.address_components[i].long_name;
        //   // console.log('city', this.city);
        //    $('#city').val(this.place.address_components[i].long_name);
        // }
        if (this.placeDetailData[i].types[j] === "locality") {
          // this.city = this.place.address_components[i].long_name;
          // console.log('city', this.city);
          $("#city").val(this.placeDetailData[i].long_name);
        }
        if (this.placeDetailData[i].types[j] === "street_number") {
          this.street = this.placeDetailData[i].long_name;
          console.log("street number", this.street);
        }
        if (this.placeDetailData[i].types[j] === "route") {
          this.street = this.street + " " + this.placeDetailData[i].long_name;
          console.log("route", this.street);
        }
        if (this.placeDetailData[i].types[j] === "sublocality_level_2") {
          this.street = this.street + " " + this.placeDetailData[i].long_name;
          console.log("sublocality 2", this.street);
        }
        if (this.placeDetailData[i].types[j] === "sublocality_level_1") {
          this.street = this.street + " " + this.placeDetailData[i].long_name;
          console.log("sublocality 1", this.street);
        }
        //   this.street = this.place.name;
        //   console.log('this.street', this.street);

        if (
          this.placeDetailData[i].types[j] === "administrative_area_level_1"
        ) {
          $("#state").val(this.placeDetailData[i].short_name);
        }

        if (this.placeDetailData[i].types[j] === "country") {
          // this.area = this.place.address_components[i].long_name;
          $("#area").val(this.placeDetailData[i].long_name);
        }

        if (this.placeDetailData[i].types[j] === "postal_code") {
          // this.zip = this.place.address_components[i].long_name;
          console.log("postal; code", this.placeDetailData[i].long_name);
          $("#zip").val(this.placeDetailData[i].long_name);
        } else {
          $("#zip").val("");
        }
      }
    }
  }
  restrictUserInput($event) {
    $event.preventDefault();
  }
  countryValidation() {
    var code = $("#phone").intlTelInput("getSelectedCountryData").dialCode;
    code = "+" + code;
    var val = $("#phoneValue").val();
    for (var i = 0; i < this.cs.country.length; i++) {
      if (code === this.cs.country[i].countryCode) {
        // console.log('val.length', val.length, this.cs.country[i].length);
        if (val.length === this.cs.country[i].length) {
          console.log("valid");
          this.numChk = false;
          $("#phoneValue").css("border-color", "#ccc");
        } else {
          console.log("invalid");
          this.numChk = true;
          $("#phoneValue").css("border-color", "#eb3b3b");
        }
      }
    }
  }
  prevent($event) {
    console.log("prevent default", $event.keyCode);
    if ($event.keyCode === 8 || $event.keyCode === 46) {
      return;
    }
    if (!($event.keyCode >= 48 && $event.keyCode <= 57)) {
      $event.preventDefault();
      return;
    }
  }
  capitlizeFirstName() {
    this.first_name = this.first_name.replace(/\b\w/g, function (l) {
      return l.toUpperCase();
    });
  }
  capitlizeLastName() {
    this.last_name = this.last_name.replace(/\b\w/g, function (l) {
      return l.toUpperCase();
    });
  }
  editClose() {
    this.customerMatch = true;
    $(".intl-tel-input").remove();
    this.findCustomer();
  }
  functionTogetPlace() {
    if (this.selectAddress === true) {
      return;
    }
    this.placeDataFound = false;
    this.placeSuggestionsData = [];
    clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
      // this.addressLoad = true;
      this.dataService.googleAddress(this.address_line1).subscribe(
        (data) => {
          this.placeSuggestionsData = data;
          this.placeSuggestionsData = this.placeSuggestionsData.predictions;
          console.log("place google data", this.placeSuggestionsData);
          this.placeDataFound = true;
          if ($(".myDrop").hasClass("open")) {
          } else {
            $(".myDrop").addClass("open");
          }
          // this.addressLoad = false;
          // $('#searchTextField').click();
          // $('#searchTextField').focus();
        },
        (error) => {}
      );
    }, 1000);
  }
  functionTogetPlaceDetail(name, id) {
    this.addressLoad = true;
    this.address_line1 = name;
    clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
      this.dataService.googleAddressDetail(id).subscribe(
        (data) => {
          console.log("place google detail data", data);
          this.placeDetailData = data;
          this.selectAddress = true;
          this.placeDetailData = this.placeDetailData.result;
          this.latitude = this.placeDetailData.geometry.location.lat;
          this.longitude = this.placeDetailData.geometry.location.lng;
          console.log("this.latitude", this.latitude);
          console.log("this.longitude", this.longitude);
          this.placeDetailData = this.placeDetailData.address_components;
          this.callMap();
          setTimeout(() => {
            this.addressDetail();
            this.addressLoad = false;
          }, 1000);
        },
        (error) => {}
      );
    }, 1000);
  }
  callMap() {
    setTimeout(() => {
      var context = this;
      var map;
      var marker;
      var adr;
      var myLatlng = new google.maps.LatLng(this.latitude, this.longitude);
      var geocoder = new google.maps.Geocoder();
      var infowindow = new google.maps.InfoWindow();
      var mapOptions = {
        zoom: 14,
        center: myLatlng,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        navigationControl: false,
        // mapTypeControl: false,
        // disableDefaultUI: true
      };
      var endImage = {
        url: "assets/pin.png", // url
        scaledSize: new google.maps.Size(50, 56), // scaled size
        origin: new google.maps.Point(0, 0), // origin
        anchor: new google.maps.Point(16, 16), // anchor
      };
      map = new google.maps.Map(document.getElementById("myMap"), mapOptions);
      if (this.customerMatch === true) {
        marker = new google.maps.Marker({
          map: map,
          position: myLatlng,
          icon: endImage,
        });
      }
      if (this.customerMatch === false) {
        marker = new google.maps.Marker({
          map: map,
          position: myLatlng,
          draggable: true,
          icon: endImage,
        });
      }
      if (this.customerMatch === false) {
        geocoder.geocode({ latLng: myLatlng }, function (results, status) {
          if (status === google.maps.GeocoderStatus.OK) {
            if (results[0]) {
              // $('#address').val(results[0].formatted_address);
              // $('#latitude').val(marker.getPosition().lat());
              // $('#longitude').val(marker.getPosition().lng());
              infowindow.setContent(results[0].formatted_address);
              infowindow.open(map, marker);
              context.latitude = marker.getPosition().lat();
              context.longitude = marker.getPosition().lng();
              console.log(context.latitude, context.longitude);
              console.log("results", results);
              // context.getDeliveryAddressDetail(results[0]);
            }
          }
        });

        google.maps.event.addListener(marker, "dragend", function () {
          geocoder.geocode(
            { latLng: marker.getPosition() },
            function (results, status) {
              if (status === google.maps.GeocoderStatus.OK) {
                if (results[0]) {
                  infowindow.setContent(results[0].formatted_address);
                  infowindow.open(map, marker);
                  context.latitude = marker.getPosition().lat();
                  context.longitude = marker.getPosition().lng();
                  // context.addressNew =  results[0].formatted_address;
                  console.log(context.latitude, context.longitude);
                  console.log("results", results);
                  // this.changeRef.detectChanges();
                  // context.getDeliveryAddressDetail(results[0]);
                }
              }
            }
          );
        });
      }
    }, 500);
  }

  resetAddress() {
    this.address_line1 = "";
    // this.address_line2 = '';
    this.city = "";
    this.state = "";
    this.zip = "";
    this.area = "";
    this.apart = "";
    this.longitude = "";
    this.latitude = "";
    this.selectAddress = false;
  }

  getcustomerOrderListing() {
    this.customerOrderListingPagination = 0;
    this.noSearchData = false;
    this.loadindData = true;
    this.dataService
      .getorderlisting(
        this.id,
        window.localStorage.getItem("token"),
        this.customerOrderListingPagination,
        this.ordertype,
        this.businessid,
        this.searchOrder,
        this.startDate,
        this.endDate
      )
      .subscribe(
        (data) => {
          this.customerOrderListing = data;
          this.lastPage = this.customerOrderListing.last_page;
          this.customerOrderListing = this.customerOrderListing.items;
          this.loadindData = false;
          console.log("customerOrderListing", this.customerOrderListing);
          if (this.customerOrderListing.length === 0) {
            this.noSearchData = true;
          }
        },
        (error) => {}
      );
  }

  CustomerOrderListingByPage() {
    this.CustomerOrderListingPage = [];
    this.customerOrderListingPagination++;
    console.log("this.id", this.id);
    this.dataService
      .getorderlisting(
        this.id,
        window.localStorage.getItem("token"),
        this.customerOrderListingPagination,
        this.ordertype,
        this.businessid,
        this.searchOrder,
        this.startDate,
        this.endDate
      )
      .subscribe(
        (data) => {
          this.CustomerOrderListingPage = data;
          this.lastPage = this.CustomerOrderListingPage.last_page;
          this.CustomerOrderListingPage = this.CustomerOrderListingPage.items;
          console.log(
            "CustomerOrderListingPage",
            this.CustomerOrderListingPage
          );
          for (var i = 0; i < this.CustomerOrderListingPage.length; i++) {
            this.customerOrderListing.push(this.CustomerOrderListingPage[i]);
          }
        },
        (error) => {}
      );
  }

  filterOrderSearch() {
    this.noSearchData = false;
    clearTimeout(this.searchTimeOut);
    this.searchTimeOut = setTimeout(() => {
      this.getcustomerOrderListing();
    }, 1000);
    if (this.customerOrderListing.length === 0) {
      this.noSearchData = true;
    }
  }

  clearSearch() {
    this.searchOrder = "";
    this.getcustomerOrderListing();
  }

  updateData(type) {
    if (type === "all") {
      this.showRangeFields = false;
      this.ordertype = 0;
      this.getcustomerOrderListing();
      return;
    }
    if (type === "today") {
      this.showRangeFields = false;
      this.ordertype = 1;
      this.getcustomerOrderListing();
      return;
    }
    if (type === "weekly") {
      this.showRangeFields = false;
      this.ordertype = 2;
      this.getcustomerOrderListing();
      return;
    }
    if (type === "monthly") {
      this.showRangeFields = false;
      this.ordertype = 3;
      this.getcustomerOrderListing();
      return;
    }
    if (type === "selectRange") {
      this.showRangeFields = true;
      this.ordertype = 4;
      setTimeout(() => {
        $(" #customerOrderReportStart, #customerOrderReportEnd").datepicker({
          format: "yyyy-m-d", // Notice the Extra space at the beginning
          defaultDate: "-10d",
          endDate: new Date(),
        });
      }, 10);
    }
  }

  // reportDetailData(type, start_date, end_date) {
  //   console.log('this.startDate', this.startDate);
  //   this.dataService.getorderlisting(window.localStorage.getItem('token'), this.id, type, start_date, end_date).subscribe(
  //     (data) => {
  //       console.log('customer data', data);
  //       this.customerOrderListing = data;
  //
  //     },
  //     (error) => {
  //
  //     }
  //   );
  // }

  sendRangeData() {
    this.startDate = $("#customerOrderReportStart").val();
    this.endDate = $("#customerOrderReportEnd").val();
    if (this.startDate === "" || this.startDate === undefined) {
      toastr.error("please select start date");
      return;
    }
    if (this.endDate === "" || this.endDate === undefined) {
      toastr.error("please select end date");
      return;
    }
    console.log("this.startDate,this.endDate", this.startDate, this.endDate);
    this.ordertype = 4;
    this.getcustomerOrderListing();
  }

  getbusinessesList() {
    this.dataService
      .getbusinessListAgainstCustomer(
        window.localStorage.getItem("token"),
        this.id
      )
      .subscribe(
        (data) => {
          this.businessAgainstCustomer = data;
          console.log(
            "this.businessAgainstCustomer",
            this.businessAgainstCustomer
          );
        },
        (error) => {}
      );
  }

  getupdateorderfilter(name, id) {
    this.filterValue = name;
    this.businessid = id;
    this.getcustomerOrderListing();
  }

  goBackToCustomerDetail() {
    $(".intl-tel-input").remove();
    console.log("this.previousStateData.page", this.previousStateData.page);
    var data = {
      id: this.id,
      page: this.previousStateData.page,
      scroll: this.previousStateData.scroll,
    };
    this.events.publish("customerDetailUpdateDone", data);
  }

  ngOnInit() {
    // this.getcustomerOrderListing();
    // this.getbusinessesList();
    const context = this;
    // this.inputAddress1();
    // this.findCustomer();
    $(document).ready(function () {
      $(this).scrollTop(0);
    });
    $(function () {
      this.maxYear = new Date().getFullYear();
      this.maxYear = parseInt(this.maxYear) - 21;
      $("#datepicker").datepicker({
        format: "mm/dd/yyyy", // Notice the Extra space at the beginning
        defaultDate: "-10d",
        endDate: new Date("12/31/" + this.maxYear),
      });
    });
  }
  selectGender(val) {
    if (this.gender != val) {
      // this.showGender = true;
    }
    this.gender = val;
  }

  /**
   * Order Detail pop up variables and functions
   */

  orderDetailToReopenOpId: any;
  orderDetailData: any;
  customerDetail: any;
  droppOffAddress: any;
  userDropDocs: any;
  orderDataDisplay: any;
  dineIn: any;
  tableNo: any;
  pickUp: any;
  pickupAddress: any;
  productData: any;
  thirdPartyData: any;
  onDetailDriverData: any;
  returnOrderItems: any;
  returnOrderItemsLength: any;
  orderCreated: any;
  orderBooked: any;
  deliverStartDate: any;
  deliverEndDate: any;

  orderDetailCall(id) {
    this.nao.go(30);
    this.orderDetailToReopenOpId = id;
    this.dataService
      .getOrderhDetail(window.localStorage.getItem("token"), id)
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.orderDetailData = data;
          this.orderDetailData.transaction_missing = false;
          if (this.orderDetailData.payment_type == "Bank Transfer") {
            this.orderDetailData.transaction_missing = true;
          }
          this.customerDetail = this.orderDetailData.customer_detail;
          this.droppOffAddress = this.orderDetailData.dropoff_address;
          // we have to work here
          this.userDropDocs = this.orderDetailData.drop_off_docs;
          console.log("userDropDocs", this.userDropDocs);
          this.orderDataDisplay = this.orderDetailData.order;
          console.log(this.orderDataDisplay);
          let order_type = this.orderDataDisplay.delivery_man_type;
          if (order_type === 4) {
            this.dineIn = true;
            this.tableNo = this.orderDataDisplay.dine_in_table_number;
          } else {
            this.dineIn = false;
            this.tableNo = "";
          }
          if (order_type === 5) {
            this.pickUp = true;
          } else {
            this.pickUp = false;
          }
          this.pickupAddress = this.orderDetailData.pickup_address;
          this.productData = this.orderDetailData.product;
          this.thirdPartyData = this.orderDetailData.third_party;
          this.onDetailDriverData = this.orderDetailData.driver;
          this.returnOrderItems = this.orderDataDisplay.return_items[
            "return_product_list"
          ];
          this.returnOrderItemsLength = this.returnOrderItems.length;
          this.orderCreated = this.orderDetailData.order_created_by;
          this.orderBooked = this.orderDetailData.order_booked_by;
          // console.log('this.orderCreated', this.orderCreated);
          console.log("this.onDetailDriverData", this.onDetailDriverData);
          $("#orderDetailPop").modal("show");

          var cDate = new Date().getDate();
          var cYear = new Date().getFullYear();
          var cMonth = new Date().getUTCMonth() + 1;
          var openTime = this.orderDataDisplay.open_time;
          var tOpen =
            cYear + "/" + cMonth + "/" + cDate + " " + openTime + " " + "UTC";
          var dateObjOpen = new Date(tOpen);
          this.deliverStartDate = dateObjOpen;

          var closeTime = this.orderDataDisplay.close_time;
          var tClose =
            cYear + "/" + cMonth + "/" + cDate + " " + closeTime + " " + "UTC";
          var dateObjClose = new Date(tClose);
          this.deliverEndDate = dateObjClose;
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }

  findDriverDataDriver: any;
  dispenseriesDriver: any;
  first_nameDriver: any;
  last_nameDriver: any;
  emailDriver: any;
  phoneDriver: any;
  noteDriver: any;
  driving_license_frontDriver: any;
  driving_license_backDriver: any;
  registration_bookDriver: any;
  userImageDriver: any;
  address_line1Driver: any;
  address_line2Driver: any;
  cityDriver: any;
  stateDriver: any;
  zipDriver: any;
  areaDriver: any;
  longitudeDriver: any;
  latitudeDriver: any;
  driverMatchDriver: any;

  driverDetails(id) {
    // this.nao.go(30);
    this.dataService.showDriverDetailWithId(window.localStorage.getItem('token'), id).subscribe(
      (data) => {
        // this.nao.go(100);
        this.findDriverDataDriver = data;
        if (this.findDriverDataDriver.rest_error_code === 1) toastr.error('Some thing went wrong');
        if (this.findDriverDataDriver.rest_error_code === 2) toastr.error('Please login again');
        if (this.findDriverDataDriver.rest_error_code === 3) toastr.error('Driver already exists');
        this.dispenseriesDriver = data;
        this.dispenseriesDriver = this.dispenseriesDriver.dispensaries;
        console.log('dispensary length', this.dispenseriesDriver.length);
        this.findDriverDataDriver = data;
        $('#datepicker').val(this.findDriverDataDriver.date_of_birth);
        this.first_nameDriver = this.findDriverDataDriver.first_name;
        this.last_nameDriver = this.findDriverDataDriver.last_name;
        this.emailDriver = this.findDriverDataDriver.email;
        this.phoneDriver = this.findDriverDataDriver.country_code + '' + this.findDriverDataDriver.phone_number;
        this.noteDriver = this.findDriverDataDriver.note;
        $('#pImg1').attr('src', this.findDriverDataDriver.licence_front_url);
        $('#pImg2').attr('src', this.findDriverDataDriver.licence_back_url);
        $('#pImg3').attr('src', this.findDriverDataDriver.reg_book_url);
        this.driving_license_frontDriver = this.findDriverDataDriver.licence_front_url;
        this.driving_license_backDriver = this.findDriverDataDriver.licence_back_url;
        this.registration_bookDriver = this.findDriverDataDriver.reg_book_url;
        this.userImageDriver = this.findDriverDataDriver.img_url;
        this.findDriverDataDriver = this.findDriverDataDriver.address;
        this.address_line1Driver = this.findDriverDataDriver.address_line1;
        this.address_line2Driver = this.findDriverDataDriver.address_line2;
        this.cityDriver = this.findDriverDataDriver.city;
        this.stateDriver = this.findDriverDataDriver.state;
        this.zipDriver = this.findDriverDataDriver.zip;
        this.areaDriver = this.findDriverDataDriver.area;
        this.longitudeDriver = this.findDriverDataDriver.longitude;
        this.latitudeDriver = this.findDriverDataDriver.latitude;
        this.driverMatchDriver = true;
        // $('#orderDetailPop').modal('hide');
        // setTimeout(() => {
        $('#driverDetailPop').modal('show');
        // }, 1000);
        console.log('cutomer data get with phone#', data);
        // }

      },
      (error) => {
        // this.nao.go(100);
        console.log('error', error);
      }
    );
  }

  modalClos(name) {
    $('#' + name).modal('hide');
    $('#orderDetailPop').css('overflow-y', 'scroll');
  }
}



// WEBPACK FOOTER //
// ./src/app/customer-detail/customer-detail.component.ts